import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import NoMatch from './pages/404';
import Privacy from './pages/privacy';
import PrivacyFull from './pages/privacy-full';
import Theme from './theme';
import Home from './home';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// Import the functions you need from the SDKs you need
import FirebaseApp from "firebase/app";
import 'firebase/analytics'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCo4UyV1eY68FACUCdKPOsa9GNOsGdaQN4",
  authDomain: "calist-68f3f.firebaseapp.com",
  projectId: "calist-68f3f",
  storageBucket: "calist-68f3f.appspot.com",
  messagingSenderId: "12756461257",
  appId: "1:12756461257:web:9d293b3eb7f84011788f18",
  measurementId: "G-72SVEWG9QQ"
};

// Initialize Firebase

const app = FirebaseApp.initializeApp(firebaseConfig);

class Root extends React.Component {
  render() {
	app.analytics();
  	return(
  		<BrowserRouter basename={'/'} >
		  	<Switch>
			  <Route exact path={`${process.env.PUBLIC_URL}/`} component={Home}/>
			  <Route exact path={`${process.env.PUBLIC_URL}/privacy`} component={Privacy}/>
			  <Route exact path={`${process.env.PUBLIC_URL}/privacy-full`} component={PrivacyFull}/>
			  <Route exact path={`${process.env.PUBLIC_URL}/terms`} component={() => { 
					window.location.href = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/'; 
					return null;
				}}/>
			  <Route exact path={`${process.env.PUBLIC_URL}/:themeId`} component={Theme}/>
			  <Route component={NoMatch} />
			</Switch>
		</BrowserRouter>
  	);
  }
 }

ReactDOM.render(<Root />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js